export const NAME = 'terminal';



// WEBPACK FOOTER //
// ./src/modules/terminal/constants.js